export function showLoadingSpinner() {
  const spinner = document.createElement('div');
  spinner.classList.add('loading-spinner');
  spinner.style.cssText = 'position:absolute;top:35%;left:50%;transform:translate(-50%,-50%);width:60px;height:60px;';
  spinner.innerHTML = `
    <svg width="60" height="60" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <circle cx="50" cy="50" r="40" stroke="#3498db" stroke-width="8" fill="none"/>
      <circle cx="50" cy="50" r="40" stroke="#f3f3f3" stroke-width="8" fill="none"
        stroke-dasharray="251" stroke-dashoffset="50" transform="rotate(-90 50 50)">
        <animate attributeName="stroke-dashoffset" values="251;0" dur="1s" repeatCount="indefinite"/>
      </circle>
    </svg>`;
  // document.body.appendChild(spinner);
}

export function hideLoadingSpinner() {
  document.querySelector('.loading-spinner')?.remove();
}
